import { TypeChecker } from '@attain-apps/type-guards'
export interface Config {
  /**
   * @default_ {@link Config.Defaults.PLACEHOLDER Placeholder}
   */
  placeholder?: string
  /**
   * Emit a search change event only after a particular time span
   * has passed without another source emission.
   *
   * @default_ {@link Config.Defaults.DEBOUNCE_TIME Debounce Time}
   */
  debounceTime?: number
}
export namespace Config {
  export const isConfig = TypeChecker.Factory.object<Config>({
    debounceTime: TypeChecker.Factory.optional(TypeChecker.isNumber),
    placeholder: TypeChecker.Factory.optional(TypeChecker.isString),
  })
  export namespace Defaults {
    export const DEBOUNCE_TIME = 300
    export const PLACEHOLDER = 'Search Here'
  }
}
